window.VjsUtility = (function(my){
    var self = my.Notification = {};

    var _defaultTime = 1500;
    var _defaultType = "success";
    var _hooks = [];

    /**
     *  @desc initializes most general notification
     *  @param params.text  text for notification
     *  @param params.time  time notification stays visible
     *  @param params.type  type of notification
     */
    self.init = function(params){
        //if params is a string, assume text
        params = (typeof params === "string") ? {text: params } : params;

        //verify text is filled in
        if(!params.text || params.text === ""){
            throw Error("Notification : missing text");
        }

        params.time = params.time ? params.time : _defaultTime;
        params.type = params.type ? params.type : _defaultType;

        _callHooks(
            params.text,
            params.time,
            params.type
        );
    }

    self.success = function(params){
        params = (typeof params === "string") ? {text: params } : params;
        params.type = "success";

        self.init(params);
    }

    self.error = function(params){
        params = (typeof params === "string") ? {text: params } : params;
        params.type = "error";

        self.init(params);
    }

    self.warning = function(params){
        params = (typeof params === "string") ? {text: params } : params;
        params.type = "warning";

        self.init(params);
    }

    self.info = function(params){
        params = (typeof params === "string") ? {text: params } : params;
        params.type = "info";

        self.init(params);
    }

    self.addHook = function(callBack){
        if(typeof callBack !== "function") throw new Error("Notifications : addHook : notification hook must be a function.");
        _hooks.push(callBack);
    }

    self.updateSettings = function(settings){
        if(typeof settings !== "object") throw new Error("Notification : updateSettings : settings must be an object.");

        _defaultTime = settings.time ? settings.time : _defaultTime;
        _defaultType = settings.type ? settings.type : _defaultType;

        //now test for a hook function
        if(settings.hook){
            if(typeof settings.hook !== "function") throw new Error("Notifications : updateSettings : hook was passed but is not a function.");
            _hooks.push(settings.hook);
        }
    }

    function _callHooks(text, time, type){
        _hooks.forEach(function(item){
            item(text, time, type);
        });
    }

    return my;
}(window.VjsUtility || {}));
